import { useFormContext, Controller } from "react-hook-form";
import Label from "../Label";
import Select from "../Select";

interface Option {
  value: string;
  label: string;
}

interface FormSelectProps {
  name: string;
  label?: string;
  options: Option[];
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  hint?: string;
  size?: "sm" | "md" | "lg";
}

/**
 * RHF-wired select using the Radix portal-based Select primitive.
 * Keeps the same external API so all consumers work without changes.
 */
export function FormSelect({
  name,
  label,
  options,
  placeholder = "Chọn...",
  className,
  disabled = false,
  required = false,
  hint,
  size = "md",
}: FormSelectProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors[name];
  const hasError = !!error;

  return (
    <div>
      {label && (
        <Label htmlFor={name}>
          {label}
          {required && <span className="ml-0.5 text-[var(--error)]">*</span>}
        </Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select
            options={options}
            placeholder={placeholder}
            value={value ?? ""}
            onChange={onChange}
            disabled={disabled}
            size={size}
            className={className}
          />
        )}
      />
      {hint && !hasError && (
        <p className="mt-1.5 text-xs text-[var(--muted-foreground)]">{hint}</p>
      )}
      {hasError && (
        <p className="mt-1.5 text-xs text-[var(--error)]">
          {error.message as string}
        </p>
      )}
    </div>
  );
}
